/* ============================================================
   Sabre listicle — progressive enhancement
   - .sb-rv scroll reveal
   - .sb-sticky reserve bar
   - .sb-tabs review filtering
   FAQ uses native <details>, so it needs no JS.
   Idempotent: safe to load more than once and re-runs inside the
   Shopify theme editor when sections are added/reloaded.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.sb-rv:not(.sb-rv-bound)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sb-rv-bound', 'sb-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sb-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.classList.add('sb-rv-bound'); io.observe(el); });
  }

  function initSticky(root) {
    var bars = (root || document).querySelectorAll('.sb-sticky:not(.sb-sticky-bound)');
    bars.forEach(function (bar) {
      bar.classList.add('sb-sticky-bound');
      var threshold = parseInt(bar.getAttribute('data-show-after'), 10);
      if (isNaN(threshold)) threshold = 600;
      var onScroll = function () {
        bar.classList.toggle('sb-show', window.pageYOffset > threshold);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initTabs(root) {
    var groups = (root || document).querySelectorAll('.sb-tabs:not(.sb-tabs-bound)');
    groups.forEach(function (group) {
      group.classList.add('sb-tabs-bound');
      var scope = group.closest('.sb-reviews') || document;
      group.addEventListener('click', function (ev) {
        var tab = ev.target.closest('.sb-tab');
        if (!tab) return;
        group.querySelectorAll('.sb-tab').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        var f = tab.getAttribute('data-f');
        scope.querySelectorAll('.sb-rev').forEach(function (r) {
          r.style.display = (f === 'all' || r.getAttribute('data-f') === f) ? '' : 'none';
        });
      });
    });
  }

  function initVideos(root) {
    var vids = (root || document).querySelectorAll('video[data-sb-video]:not(.sb-video-bound)');
    if (!vids.length) return;
    var play = function (v) {
      // Keep autoplay policy happy: stay muted, then attempt play.
      v.muted = true;
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.classList.add('sb-video-bound'); play(v); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { play(v); }
        else if (!v.paused) { v.pause(); }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { v.classList.add('sb-video-bound'); io.observe(v); });
  }

  function initAll(root) {
    initReveal(root);
    initSticky(root);
    initTabs(root);
    initVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify theme editor: re-bind when a section is loaded/reordered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
